import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  text: {
    color: '#fff',
    fontSize: 24,
    fontWeight: 700,
    letterSpacing: '-0.02em',
    whiteSpace: 'nowrap',
  },
});

export const LogoFull = () => {
  const classes = useStyles();
  return <span className={classes.text}>Playpilot</span>;
};
